/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the LnrpLoginDto interface.
 */
export function instanceOfLnrpLoginDto(value) {
    if (!('username' in value) || value['username'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    return true;
}
export function LnrpLoginDtoFromJSON(json) {
    return LnrpLoginDtoFromJSONTyped(json, false);
}
export function LnrpLoginDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'username': json['username'],
        'password': json['password'],
    };
}
export function LnrpLoginDtoToJSON(json) {
    return LnrpLoginDtoToJSONTyped(json, false);
}
export function LnrpLoginDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'username': value['username'],
        'password': value['password'],
    };
}
